module.exports = __webpack_public_path__ + "static/media/logo.48227d67.svg";